/**
 * Single source of truth for env-var reads in the time bundle.
 *
 * Vite injects `import.meta.env.*` at build time. See `vite-env.d.ts` for the
 * typed shape.
 */

export const PUBLIC_PTC_REST_URL = import.meta.env.PUBLIC_PTC_REST_URL ?? "";
